import InstancesPage from './instances'

// Shallow redirect to Instances page
export default InstancesPage
